import { useState } from 'react';

interface UseUnsavedChangesGuardOptions {
  dirty: boolean;
  onDiscard: () => void;
}

export function useUnsavedChangesGuard({
  dirty,
  onDiscard,
}: UseUnsavedChangesGuardOptions) {
  const [confirmationOpen, setConfirmationOpen] = useState(false);

  const requestClose = () => {
    if (!dirty) {
      onDiscard();
      return;
    }
    setConfirmationOpen(true);
  };

  const confirmDiscard = () => {
    setConfirmationOpen(false);
    onDiscard();
  };

  return {
    confirmationOpen,
    setConfirmationOpen,
    requestClose,
    confirmDiscard,
  };
}
